import {
  Link
} from "./chunk-DVOZJZGH.js";
import "./chunk-MLKGABMK.js";
export {
  Link as default
};
